import { render, staticRenderFns } from "./GroupedButton.vue?vue&type=template&id=04c862f6"
import script from "./GroupedButton.vue?vue&type=script&lang=js"
export * from "./GroupedButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports